import { fetchAdminPortalProblemReportBundle } from 'services/api/admin/portalProblemReports';

// Revoked later rather than right after click: some Safari versions cancel a download whose URL is
// revoked immediately.
const REVOKE_DELAY_MS = 40_000;

// The debug bundle as the file the extension's debug kit reads (`make report-kit FILE=…`).
export async function downloadProblemReportBundle(id: string) {
  const bundle = await fetchAdminPortalProblemReportBundle(id);
  const url = window.URL.createObjectURL(
    new Blob([JSON.stringify(bundle, null, 2)], { type: 'application/json;charset=utf-8' })
  );
  const link = document.createElement('a');
  link.href = url;
  link.download = `portal-problem-report-${id}.json`;
  link.click();
  setTimeout(() => window.URL.revokeObjectURL(url), REVOKE_DELAY_MS);
}
